import { useState, useCallback } from 'react'

interface Toast {
  id: number
  message: string
  type: 'info' | 'success' | 'error' | 'warning'
}

let toastId = 0

// Global toast function — can be called from anywhere
let globalAddToast: ((message: string, type?: Toast['type']) => void) | null = null

export function showToast(message: string, type: Toast['type'] = 'info') {
  if (globalAddToast) {
    globalAddToast(message, type)
  }
}

export default function ToastContainer() {
  const [toasts, setToasts] = useState<Toast[]>([])

  const addToast = useCallback((message: string, type: Toast['type'] = 'info') => {
    const id = ++toastId
    setToasts((prev) => [...prev, { id, message, type }])
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id))
    }, 3000)
  }, [])

  // Register global function
  globalAddToast = addToast

  return (
    <div className="toast-container" id="toast-container">
      {toasts.map((toast) => (
        <div key={toast.id} className={`toast ${toast.type}`}>
          {toast.message}
        </div>
      ))}
    </div>
  )
}
